<template>
  <DefaultLayout>
    <template #buttons>
      <RoleCreateAction @created="reload" v-if="can('ROLE_MANAGE')" />
    </template>

    <RoleFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('Roles') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ roles.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
    </RoleFilter>

    <RoleList :pagination="pagination" :roles="roles" :loading="loading" :autoLazyLoad="!!pagination.nextPageURI"
      @deleted="reload" @updating="loading = true" @updated="reload" @next="nextPage" @goToPage="goToPage" />
  </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import RoleCreateAction from "@/components/role/RoleCreateAction.vue";
import RoleFilter from "@/components/role/RoleFilter.vue";
import RoleList from "@/components/role/RoleList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    RoleCreateAction,
    RoleFilter,
    RoleList,
  },
  data() {
    return {
      listPropertyName: 'roles',
      apiResource: `roles`,
      roles: [],
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Roles'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  computed: {
    actions() {
      return [
        {
          label: this.i18n('Import'),
          fn: () => {
            this.showProfileRoleImportModal();
          },
          if: this.can('ROLE_MANAGE'),
        },
        {
          label: this.i18n('Export'),
          fn: () => {
            this.showProfileRoleExportModal();
          },
          if: this.can('ROLE_ACCESS') || this.can('ROLE_MANAGE'),
        },
      ];
    },
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'role';
    },
  },
};
</script>
